// extracted by mini-css-extract-plugin
export default {"video_message":"styles_video_message__Z5txd"};